<template>
  <div class="v-main-menu">
    <nav class="">
      <ul class="nav flex-column">
        <li class="nav-item pb-1">
          <router-link class="nav-link" to="/dashboard">
            <font-awesome-icon class="" :icon="['fas', 'tachometer-alt']" size="1x"/>
            <strong>Обзор</strong>
          </router-link>
        </li>
        <li v-if="userRole === 'administrator'" class="nav-item pb-1">
          <router-link class="nav-link" to="/employees">
            <font-awesome-icon class="" :icon="['fas', 'users']" size="1x"/>
            <strong>Сотрудники</strong>
          </router-link>
        </li>
        <li v-if="userRole === 'administrator'" class="nav-item pb-1">
          <router-link class="nav-link" to="/dealers">
            <font-awesome-icon class="" :icon="['fas', 'project-diagram']" size="1x"/>
            <strong>Дилеры</strong>
          </router-link>
        </li>
        <li v-if="userRole === 'employee' || userRole === 'administrator'" class="nav-item pb-1">
          <router-link class="nav-link" to="/subscribers">
            <font-awesome-icon class="" :icon="['fas', 'users']" size="1x"/>
            <strong>Подписчики</strong>
          </router-link>
        </li>
        <li v-if="userRole !== 'subscriber'" class="nav-item">
          <router-link class="nav-link" to="/subscriptions">
            <font-awesome-icon class="" :icon="['fas', 'address-card']" size="1x"/>
            <strong>Подписки</strong>
          </router-link>
        </li>
        <li v-if="userRole !== 'subscriber'" class="nav-item">
          <router-link class="nav-link" to="/tariffs">
            <font-awesome-icon class="" :icon="['fas', 'file-invoice-dollar']" size="1x"/>
            <strong>Тарифы</strong>
          </router-link>
        </li>
        <li v-if="userRole !== 'subscriber'" class="nav-item">
          <router-link class="nav-link" to="/sim-card">
            <font-awesome-icon class="" :icon="['fas', 'mobile-alt']" size="1x"/>
            <strong>SIM карты</strong>
          </router-link>
        </li>
        <li v-if="userRole === 'administrator'" class="nav-item">
          <router-link class="nav-link" to="/finance">
            <font-awesome-icon class="" :icon="['fas', 'cash-register']" size="1x"/>
            <strong>Платежи</strong>
          </router-link>
        </li>
        <li v-if="userRole === 'administrator' || userRole === 'dealer'" class="nav-item">
          <router-link class="nav-link" to="/reports">
            <font-awesome-icon class="" :icon="['fas', 'chart-bar']" size="1x"/>
            <strong>Отчеты</strong>
          </router-link>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
export default {
  name: 'v-main-menu',
  props: {
    userRole: {
      required: true,
    },
  },
};
</script>
